// Ensure styled-components theme types are loaded
import './types/global.d'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider, GlobalStyles } from '@popety-io/ui'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { useAppSelector } from './store/hooks'
import Header from './components/Header'
import { MissingTranslationsPanel } from './components/DevTools'
import AppRoutes from './navigation/Routes'
import { AppGlobalStyles } from './styles/AppGlobalStyles'
// Import MapboxGL Draw CSS for drawing functionality
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'

const AppContent = () => {
  const themeVariant = useAppSelector((state) => state.app.themeVariant)

  return (
    <ThemeProvider variant={themeVariant}>
      <GlobalStyles />
      <AppGlobalStyles />
      <BrowserRouter>
        <Header />
        <AppRoutes />
      </BrowserRouter>
      <MissingTranslationsPanel />
    </ThemeProvider>
  )
}

const App = () => {
  return (
    <>
      <AppContent />
      <ToastContainer
        position="top-center"
        autoClose={8000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        style={{ zIndex: 99999 }}
      />
    </>
  )
}

export default App
